﻿import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from 'src/app/_services/rest.service';
import { AlertService } from 'src/app/_services';
import { Lista } from 'src/app/_models';


@Component({ templateUrl: 'gracias.component.html' })
export class GraciasComponent implements OnInit {

    id: number;

    lista: Lista;

    error: boolean = false;

    activa: boolean = false;


    constructor(private restService: RestService, private route: ActivatedRoute, private router: Router, private alertService: AlertService) {
        this.error= false;
        this.route.params.subscribe(params => {
            if (params['id']) {
                this.id = JSON.parse(params['id']);
                this.load();
            } else {
                this.error= true;
            }
            
        });
        this.route.queryParams.subscribe(params => {
            if (params['active']) {
                this.activa = params['active'].toString().toUpperCase() === 'TRUE';
            }
        });
    }


    ngOnInit() {
        this.error= false;
    }


    
    private load() {
        this.restService.get('/rest-api/user/lista/' + this.id).subscribe(
            data => {
                this.lista = data;
                if (!data)
                    this.error = true;
            }
        );
    }

    private probarMail() {
        this.restService.get('/rest-api/user/lista/mail').subscribe(
            data => {
                if (data) {
                    this.alertService.success('<h3>Listo!</h3>Control&aacute; tus mails.<br/>No te olvides de mirar la carpeta spam y marcarlo como correo deseado.', false, false);
                } else {
                    this.alertService.error('<h3>Ups</h3>Tenemos un problema con el env&iacute;o de mails.<br/>Nos mand&aacute;s un mail para avisarnos del problema?', false, false);
                }
                
            }
        );
    }



    private link(): string {
        return document.location.href.toString().replace('/user/gracias/'+this.id+'?active=true','/elegir?nombre=' + this.lista.nombre + '&codigo=' + this.lista.codigo);
    }

    linkWS(): string {
        return 'https://wa.me/?text=' + encodeURIComponent(this.link());
    }

    /* To copy any Text */
    copyText() {
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = this.link();
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }

}
